
import React from 'react';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';

export function SubmissionDetailSkeleton() {
  return (
    <div className="space-y-6">
      <div className="flex items-center gap-4">
        <Button variant="ghost" size="icon" asChild>
          <Link to="/admin/submissions">
            <ArrowLeft className="h-4 w-4" />
          </Link>
        </Button>
        <h1 className="text-2xl font-bold">Detalles del Envío</h1>
      </div>

      {/* Skeleton para SubmissionInfo */}
      <Card>
        <CardHeader>
          <div className="flex items-center justify-between">
            <CardTitle>Información del Envío</CardTitle>
            <Skeleton className="h-6 w-16" />
          </div>
        </CardHeader>
        <CardContent className="space-y-6">
          <section className="space-y-2">
            <h3 className="text-lg font-semibold">Detalles</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="space-y-2">
                <Skeleton className="h-4 w-20" />
                <Skeleton className="h-4 w-32" />
              </div>
              <div className="space-y-2">
                <Skeleton className="h-4 w-20" />
                <Skeleton className="h-4 w-32" />
              </div>
              <div className="space-y-2">
                <Skeleton className="h-4 w-20" />
                <Skeleton className="h-4 w-48" />
              </div>
              <div className="space-y-2">
                <Skeleton className="h-4 w-20" />
                <Skeleton className="h-4 w-24" />
              </div>
            </div>
          </section>

          <div className="space-y-4">
            <div className="flex flex-wrap gap-2">
              <Skeleton className="h-10 w-32" />
              <Skeleton className="h-10 w-28" />
              <Skeleton className="h-10 w-36" />
            </div>
            <div className="flex flex-wrap gap-2">
              <Skeleton className="h-10 w-28" />
            </div>
          </div>
        </CardContent>
      </Card>

      {/* Skeleton para RAGv2Preview */}
      <Card>
        <CardHeader>
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <Skeleton className="h-5 w-5" />
              <CardTitle>RAG v2 - Respuestas IA por Sección</CardTitle>
              <Skeleton className="h-6 w-16" />
            </div>
            <Skeleton className="h-10 w-32" />
          </div>
        </CardHeader>
        <CardContent>
          <div className="space-y-4">
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-4 w-3/4" />
            <Skeleton className="h-4 w-1/2" />
          </div>
        </CardContent>
      </Card>

      {/* Skeleton para AnswersDisplay */}
      <Card>
        <CardHeader>
          <CardTitle>Respuestas</CardTitle>
        </CardHeader>
        <CardContent className="space-y-8">
          {[1, 2].map((categoryIndex) => (
            <div key={categoryIndex} className="mb-10 bg-gray-50 p-4 rounded-lg shadow-sm border border-gray-200">
              <Skeleton className="h-6 w-48 mb-4" />
              <div className="space-y-6 pl-2">
                {[1, 2].map((subIndex) => (
                  <div key={subIndex} className="bg-white rounded-lg border border-gray-100 p-4 shadow-inner">
                    <Skeleton className="h-5 w-32 mb-2" />
                    <div className="divide-y divide-gray-100 pl-2">
                      {[1, 2, 3].map((qIndex) => (
                        <div key={qIndex} className="py-3">
                          <Skeleton className="h-4 w-full mb-1" />
                          <Skeleton className="h-4 w-3/4" />
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </CardContent>
      </Card>
    </div>
  );
}
